import { __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { CheckboxSvg } from '../Checkbox/CheckboxSvg.js';
import { RadioSvg } from '../Radio/RadioSvg.js';
import { useSelectableOption } from './useSelectableOption.js';
import { Inline } from '../Inline/Inline.js';

var SelectableOption = function (props) {
    var children = props.children, option = props.option, _a = props.themeKey, themeKey = _a === void 0 ? "selectableOption" : _a;
    var handleStyleProps = useTheme().handleStyleProps;
    var _b = useSelectableOption(option), liProps = _b.props, look = _b.look, size = _b.size, multiple = _b.multiple, highlightSelected = _b.highlightSelected;
    var disabled = option.disabled, label = option.label, selected = option.selected;
    var css = handleStyleProps(__assign({ highlightSelected: highlightSelected, look: look, size: size }, props), {
        themeKey: themeKey,
        baseStyle: { boxSizing: "border-box" },
    }).css;
    if (children) {
        return (jsx("li", __assign({}, liProps, { css: css }, { children: children })));
    }
    if (multiple) {
        return (jsx("li", __assign({}, liProps, { css: css }, { children: jsxs(Inline, __assign({ gap: "0" }, { children: [jsx(CheckboxSvg, { isChecked: selected, isDisabled: disabled, sx: { marginRight: 3 } }), label] })) })));
    }
    return (jsx("li", __assign({}, liProps, { css: css }, { children: jsxs(Inline, __assign({ gap: "0" }, { children: [jsx(RadioSvg, { size: size, isChecked: selected, isDisabled: disabled, sx: { marginRight: 3 } }), label] })) })));
};

export { SelectableOption };
//# sourceMappingURL=SelectableOption.js.map
